import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-4 whitespace-nowrap">
            读者心声
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画读者真实评价
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">来自千万读者的真实反馈，用口碑见证品质</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-6">
          {commentsData.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-lg border border-background-200/70 p-5 md:p-6"
            >
              <div className="flex items-start gap-3 mb-4">
                <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 rounded-full bg-primary-100 flex items-center justify-center">
                  <span className="text-sm font-bold text-primary-600">{item.avatar}</span>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{item.name}</h3>
                  <div className="flex items-center gap-0.5 mt-0.5">
                    {[...Array(5)].map((_, j) => (
                      <i
                        key={j}
                        className={`text-xs ${j < item.rating ? 'ri-star-fill text-amber-400' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </div>
                </div>
                <span className="text-[10px] md:text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">{item.date}</span>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}